(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai-gen-block-video"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('sv-shoppable-videos')) return;

    class SvShoppableVideos extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.sv__list');
        this.videos = Array.from(this.querySelectorAll('video'));
        this.setupVideos();
        if (this.dataset.mode === 'carousel' && this.list) this.setupCarousel();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
      }

      /* Play only while visible; nothing downloads before that */
      setupVideos() {
        const showControls = this.dataset.controls === 'true';
        this.videos.forEach((v) => {
          v.muted = true;
          v.setAttribute('muted', '');
          v.loop = true;
          v.playsInline = true;
          v.setAttribute('playsinline', '');
          v.removeAttribute('autoplay');
          if (!showControls) { v.controls = false; v.removeAttribute('controls'); }
        });
        const play = (v) => { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
        if (!('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) play(e.target); else e.target.pause(); });
        }, { threshold: 0.4 });
        this.videos.forEach((v) => this.io.observe(v));
      }

      setupCarousel() {
        this.items = Array.from(this.list.querySelectorAll('.sv__item'));
        this.nav = this.querySelector('.sv__nav');
        this.prev = this.querySelector('[data-sv-prev]');
        this.next = this.querySelector('[data-sv-next]');
        const smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const step = () => (this.items.length > 1 ? this.items[1].offsetLeft - this.items[0].offsetLeft : this.list.clientWidth);
        const max = () => Math.max(0, this.list.scrollWidth - this.list.clientWidth);
        const go = (dir) => {
          const left = Math.round(this.list.scrollLeft / (step() || 1) + dir) * step();
          this.list.scrollTo({ left: Math.max(0, Math.min(left, max())), behavior: smooth });
        };
        const update = () => {
          if (this.nav) this.nav.hidden = max() <= 2;
          if (this.prev) this.prev.disabled = this.list.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.list.scrollLeft >= max() - 2;
        };
        if (this.prev) this.prev.addEventListener('click', () => go(-1));
        if (this.next) this.next.addEventListener('click', () => go(1));
        let ticking = false;
        this.list.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => { update(); ticking = false; });
        }, { passive: true });
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(update);
          this.ro.observe(this.list);
        }
        update();

        /* Mouse drag on desktop (touch uses native swipe) */
        let down = false, moved = false, startX = 0, startLeft = 0;
        this.list.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (e.target.closest('form, a, select, button')) return;
          down = true; moved = false; startX = e.clientX; startLeft = this.list.scrollLeft;
        });
        this.list.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 5) { moved = true; this.list.classList.add('is-dragging'); }
          if (moved) this.list.scrollLeft = startLeft - dx;
        });
        const end = () => {
          if (!down) return;
          down = false;
          if (!moved) return;
          this.list.classList.remove('is-dragging');
          go(0);
          setTimeout(() => { moved = false; }, 0);
        };
        this.list.addEventListener('pointerup', end);
        this.list.addEventListener('pointerleave', end);
        this.list.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      }
    }

    customElements.define('sv-shoppable-videos', SvShoppableVideos);
  })();
  } catch(e) { console.error(e); }
})();

})();
